import { forwardRef } from 'react';

export const CustomIcon = forwardRef((props, ref) => {
  const { icon: IconComponent, ...restProps } = props;

  return <IconComponent {...restProps} ref={ref} />;
});
